export const isExternalLink = (href: string) => href.startsWith("//") || href.startsWith("http");
